var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.object)?_c('span',[_vm._v(_vm._s(_vm.characterId))]):_c('a',{attrs:{"href":'/player/' + _vm.object.id}},[_vm._v(_vm._s(_vm.object.character ? _vm.object.character.name : _vm.characterId))])])}
var staticRenderFns = []

export { render, staticRenderFns }